module.exports = __webpack_public_path__ + "media/images/official/event_fukidashi1-902cb44c73e11a2c6cde177f0cc6bb42.png";